import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import Header from '../components/header'
import Logo from '../images/cohoots-foundation-logo.png'

import './index.scss'

import ogImgage from '../images/favico-128.png'

// const Layout = ({ children, data }) => <div className="">{children()}</div>

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title="Youth ChangeMaker Summit"
      meta={[
        {
          name: 'description',
          content:
            'Youth ChangeMaker Summit is an entrepreneurship event for high school students.',
        },
      ]}
    />

    <Header siteTitle={data.site.siteMetadata.title} />

    <main className="">{children()}</main>
    <footer>
      <section className="grid-x grid-padding-x">
        <div className="cell medium-3">
          <p>
            <strong>Event Information</strong>
          </p>
          <nav>
            {/* <a href="#">About</a> */}
            {/* <a href="#">Past/Future Events</a> */}
            <Link to="/register/">Register</Link>
            <Link to="/sponsorship/">Sponsorships</Link>
            <a
              href="https://cohootsfdn.typeform.com/to/ljmBkf"
              rel="noindex, nofollow, noopener"
            >
              Mentorship
            </a>
          </nav>
        </div>
        <div className="cell medium-3">
          <p>
            <strong>Youth ChangeMaker Summit</strong>
          </p>
          <nav>
            <a href="https://www.cohootsfdn.org/">CO+HOOTS Foundation</a>
            {/* <a href="#">Student Ventures</a> */}
            {/* <a href="#">Education Resources</a> */}
            {/* <a href="#">Press</a> */}
            {/* <a href="#">Contact</a> */}
          </nav>
        </div>
        <div className="cell medium-3">
          <p>
            <strong>Social Media</strong>
          </p>
          <nav>
            {/* <a href="https://twitter.com/ycmsummit">Twitter</a> */}
            {/* <a href="#">Facebook</a> */}
            <a href="https://twitter.com/cohootsfdn">
              CO+HOOTS Foundation on Twitter
            </a>
            <a href="https://www.facebook.com/cohootsfdn/">
              CO+HOOTS Foundation on Facebook
            </a>
          </nav>
        </div>
        <div className="cell medium-auto grow">
          <a
            href="https://cohootsfdn.org"
            title="Presented by the Co+Hoots Foundation"
          >
            <img
              src={Logo}
              alt="CO+HOOTS Foundation Logo"
              style={{ width: '250px' }}
            />
          </a>
        </div>
      </section>
      <section>
        <div className="cell">
          <p>&copy; 2020 CO+HOOTS Foundation</p>
        </div>
      </section>
    </footer>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js